const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Service for adding and updating multiple users at a time
 * @argument {Application} Application defines the Application service
 * @argument {Users} Users defines the Users resource
 * @argument {Surveys} Surveys defines the Surveys resource
 */
app.factory('SurveyHelper', ['Application', 'Authorization', 'Users', 'Surveys', 'i18n', '$q', 'Articles', 'Videos', 'Files', 'Tracks', 'ScormContent', 'Assessments', 'Workshops', '$translate', function (Application, Authorization, Users, Surveys, i18n, $q, Articles, Videos, Files, Tracks, ScormContent, Assessments, Workshops, $translate) {

  const userCompletedContentSurvey = async function(surveyId, contentId) {
    try {
      const userSurvey = await Surveys.getResult({subresource: surveyId, subsubsubresource: contentId}).$promise;
      return !!userSurvey.date_completed;
    } catch (e) {
      console.log(e);
    }
  }

  const getOneSurvey = async (surveyId) => {
    try {
      const survey = await Surveys.get({subresource: surveyId}).$promise;
      return survey;
    } catch (e) {
      console.error('Error retrieving survey: ', e);
    }
  }

  const getPartialResults = async (surveyId, contentId) => {
    try {
      const results = await Surveys.getResult({subresource: surveyId, subsubsubresource: contentId}).$promise;
      return results;
    } catch (e) {
      console.error('Error getting User Survey results: ', e);
    }
  }

  const addIdToElement = (elementObject, idString) => {
    return {...elementObject, _id: idString};
  }
  
  const constructQuestionsByName = (pages, questions) => {
    let elementIndex = 0;
    const questionsByName = {};
    const mapElements = (elements) => {
      for (const element of elements) {
        if (element.elements) {
          mapElements(element.elements);
        } else {
          questionsByName[element.name] = addIdToElement(element, questions[elementIndex]._id);
          elementIndex++;
        }
      }
    };
    for (const page of pages) {
      mapElements(page.elements);
    }
    return questionsByName;
  }

  const constructSubmissionBody = (responses, questionsByName, surveyId, contentId, contentType) => {
    const results = [];
    const otherResponseQuestions = [];
    for (const questionName in responses) {
      if (questionName.length > 8 && questionName.slice(-8) === '-Comment') {
        otherResponseQuestions.push({
          id: questionsByName[questionName.slice(0, -8)]._id,
          answer: responses[questionName],
        });
        continue;
      }
      results.push({
        question: questionsByName[questionName]._id,
        answer: responses[questionName],
      });
    }
    for (const otherResponseQuestion of otherResponseQuestions) {
      for (const result of results) {
        if (result.question === otherResponseQuestion.id) {
          const otherAnswer = `${self.translations['hostSurveys.otherResponse']}${otherResponseQuestion.answer}`;
          if (Array.isArray(result.answer)) {
            result.answer.splice(result.answer.indexOf('other'), 1, otherAnswer);
          } else {
            // TODO translate 'other -'
            result.answer = otherAnswer;
          }
        }
      }
    }
    const body = {
      results,
      survey_id: surveyId,
      content_id: contentId,
      content_type: contentType,
    };
    return body;
  };

  const submitSurveyResults = async (body) => {
    try {
      await Surveys.submit({}, body).$promise;
    } catch (e) {
      console.error('Error submitting survey answers: ', e);
      throw Error();
    }
  }

  const hideSurvey = async (inHiddenSurveyContext, surveyId, contentId) => {
    if (inHiddenSurveyContext || !surveyId) {
      return true;
    }

    const completed = await userCompletedContentSurvey(surveyId, contentId);
    return completed;
  }
  
  const getSurveyjsLanguage = (userLanguage) => i18n.language_codes_surveyjs[userLanguage] ? i18n.language_codes_surveyjs[userLanguage] : 'en';

  const chipSearchOmittedContentTypes = ['article', 'video', 'file', 'track', 'scorm', 'imported_content', 'assessment', 'workshop', 'journey'];

  $translate(['hostSurveys.otherResponse']).then(function(translations) {
    self.translations = translations;
  });

  return {
    userCompletedContentSurvey,
    getOneSurvey,
    getPartialResults,
    constructQuestionsByName,
    constructSubmissionBody,
    submitSurveyResults,
    getSurveyjsLanguage,
    chipSearchOmittedContentTypes,
    hideSurvey
  };
}]);

